import { computed } from 'vue';
import { useDisplay } from 'vuetify';

export function useResponsive() {
  const display = useDisplay();

  // Breakpoint-Eigenschaften
  const isMobile = computed(() => display.mobile.value);
  const isTablet = computed(() => display.sm.value);
  const isDesktop = computed(() => display.mdAndUp.value);
  const isXs = computed(() => display.xs.value);
  const isSm = computed(() => display.sm.value);
  const isMd = computed(() => display.md.value);
  const isLg = computed(() => display.lg.value);
  const isXl = computed(() => display.xl.value);

  // Container-Klassen
  const containerClasses = computed(() => ({
    'pa-8': isXs.value,
    'pa-12': isSm.value,
    'pa-16': isMd.value,
    'pa-16 ml-n16': isLg.value,
  }));

  // Titel-Klassen
  const titleClasses = computed(() => ({
    'text-h5': isXs.value,
    'text-h4': isSm.value,
    'text-h4 font-weight-bold mb-2': isMd.value,
  }));

  // Untertitel-Klassen
  const subtitleClasses = computed(() => ({
    'text-body-1': isXs.value,
    'text-h6': isSm.value,
    'text-h6 text--secondary': isMd.value,
  }));

  // Row-Klassen (Breite)
  const rowClasses = computed(() => ({
    'w-100': isXs.value,
    'w-90': isSm.value,
    'w-75': isMd.value,
    'w-66 h-100': isLg.value,
  }));

  // Body-Text-Klassen
  const bodyTextClasses = computed(() => ({
    'text-caption': isXs.value,
    'text-body-2': isSm.value,
    'text-body-1': isMd.value,
  }));

  // Responsive Width Klassen
  const responsiveWidth = computed(() => ({
    'w-100': isXs.value,
    'w-90': isSm.value,
    'w-75': isMd.value,
    'w-66': isLg.value,
    'w-50': isXl.value,
    }));

  // Button-Größe
  const buttonSize = computed(() => {
    if (isXs.value) return 'small';
    if (isSm.value) return 'default';
    return 'large';
  });

  // Spalten-Konfiguration
  const columnClasses = computed(() => ({
    'cols-12': isXs.value,
    'cols-6': isSm.value,
    'cols-4': isMd.value,
    'cols-3': isLg.value,
  }));
    

  // Timeline-Dichte
  const timelineDensity = computed(() => 
    isXs.value ? 'compact' : 'comfortable'
  );

  // Timeline-Seite (Ausrichtung)
  const timelineSide = computed(() => {
    if (isMobile.value) return 'end';
    if (isTablet.value || isDesktop.value) return 'alternate';
    return 'start';
  });

  // Timeline-Align
  const timelineAlign = computed(() => 
    isMobile.value ? 'start' : undefined
  );

  // Schritt-Titel-Klassen
  const stepTitleClasses = computed(() => ({
    'text-h6': isXs.value,
    'text-h5': isSm.value,
    'headline': isMd.value,
  }));

  // Schritt-Inhalt-Klassen
  const stepContentClasses = computed(() => ({
    'text-body-2': isXs.value,
    'text-body-1': isSm.value,
  }));

  return {
    // Breakpoint-Eigenschaften
    isMobile,
    isTablet,
    isDesktop,
    isXs,
    isSm,
    isMd,
    isLg,
    isXl,

    // Klassen-Objekte

// Responsive Klassen
    containerClasses,
    titleClasses,
    subtitleClasses,
    bodyTextClasses,
    rowClasses,
    timelineDensity,
    timelineSide,
    timelineAlign,
    stepTitleClasses,
    stepContentClasses,
    responsiveWidth,
    columnClasses,  
    
    // Responsive Werte
    buttonSize,
    
    // Raw display für erweiterte Nutzung
    display
  };
}